import { render, staticRenderFns } from "./amenity.vue?vue&type=template&id=5b76e8ac&scoped=true&"
import script from "./amenity.vue?vue&type=script&lang=js&"
export * from "./amenity.vue?vue&type=script&lang=js&"
import style0 from "./amenity.vue?vue&type=style&index=0&id=5b76e8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b76e8ac",
  null
  
)

export default component.exports